module.exports = __webpack_public_path__ + "static/media/Schoonmaak.872106cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Schoonmaak.jpg
// module id = 324
// module chunks = 0